import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as utils from "../../../_metronic/utils/utils";
import { login } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import Login from "./Login";
import PrimeiroAcesso from "./PrimeiroAcesso";
import RecuperarSenha from "./RecuperaSenha";
import { swalCustom } from "../../utils/Utils";

function AuthBox(props) {
	const [page, setPage] = useState('LOGIN');
	const [email, setEmail] = useState('');
	const [loading, setLoading] = useState('');

	const handlePrimeiroAcesso = (email) => {
		setPage('PRIMEIRO');
		setEmail(email);
		setLoading(false);
	}

	const handle = (values) => {
		setLoading(true);

		login(values.email, values.password, values.primeiroAcesso).then((res) => {
			const { data } = res;

			if (data.primeiroAcesso) {
				return handlePrimeiroAcesso(data.email);
			}

			utils.setStorage("authToken", data.token);
			props.login(data);

			setLoading(false);
		}).catch((err) => {
			setLoading(false);

			const mensagem = err?.response?.data?.errors?.[0];

			swalCustom("Ops!", typeof mensagem === 'string' ? mensagem : 'Não foi possível entrar. Tente novamente em alguns instantes.', 'error');
		});
	}

	return (
		<>
			{page === 'LOGIN' && <Login setPage={setPage} handle={handle} loading={loading} />}

			{page === 'PRIMEIRO' && <PrimeiroAcesso email={email} loading={loading} setPage={setPage} handle={handle} />}

			{page === 'SENHA' && <RecuperarSenha setPage={setPage} loading={loading} setLoading={setLoading}/>}
		</>
	)
}

export default connect(null, auth.actions)(AuthBox);